// promoción compra A y B y recibe C
import { useState } from 'react';

import ProductItem from '../Product/ProductItem';
import ProductSelect from '../Product/ProductSelect';

import { savePromoToBD } from '../../../../actions/admin/promotion';
import { basicMsg, confirmDialog } from '../../../../actions/swal_msg';
import { getProductPromotions } from '../../../../helpers/admin/promotion/promotionHelper';

import {
    Typography, Grid, Stack, Button, Alert
} from "@mui/material";
import StarPurple500Icon from '@mui/icons-material/StarPurple500';

import { PROMO_PRODUCT } from '../../../../constants/shop/promotion/promotion_const';

const PromoTwo = ({
    today, promotion, allProducts,
    activePromotion, setActivePromotion,
    otherPromotion, setOtherPromotion
}) => {
    const { promo, start_date, end_date } = promotion;
    // producto A seleccionado
    const [productA, setProductA] = useState(PROMO_PRODUCT);
    // producto B seleccionado
    const [productB, setProductB] = useState(PROMO_PRODUCT);
    // producto C seleccionado
    const [productC, setProductC] = useState(PROMO_PRODUCT);

    // verificar si productos tienen promoción
    const checkPromo = async () => {
        // mismos productos seleccionados
        if (productA.variant_id === productB.variant_id) basicMsg('Producto A y B son iguales');
        else if (productA.variant_id === productC.variant_id) basicMsg('Producto A y C son iguales');
        else if (productB.variant_id === productC.variant_id) basicMsg('Producto B y C son iguales');
        else {
            const ActivePromotions = getProductPromotions(promo, activePromotion, otherPromotion, { productA, productB, productC });
            if (ActivePromotions.status) {
                if (await confirmDialog('¿Registrar la promoción?', ActivePromotions.html, 'Registrar'))
                    savePromo();
            } else savePromo();
        }
    };

    // guardar promoción en BD
    const savePromo = async () => {
        const Model = {
            ...promotion,
            variant_a: {
                ...productA,
                _id: productA.variant_id,
            },
            variant_b: {
                ...productB,
                _id: productB.variant_id,
            },
            variant_c: {
                ...productC,
                _id: productC.variant_id,
            }
        };
        const req = await savePromoToBD(Model, 'save-promo-two');
        if (req.status) {
            const { _id } = req.resp;
            // promoción activa
            if (start_date <= today && end_date >= today)
                setActivePromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            else // promoción guardada (no activa)
                setOtherPromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            // limpiar campos
            setProductA(PROMO_PRODUCT);
            setProductB(PROMO_PRODUCT);
            setProductC(PROMO_PRODUCT);
        }
    };

    return (
        <Grid container spacing={6}>
            <Grid item xs={12}>
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={2}
                    sx={{ mb: 2 }}>
                    <Typography variant="h6">
                        Promoción - En compra de producto A y B, producto C gratis
                    </Typography>
                    <StarPurple500Icon />
                </Stack>

                <Grid container spacing={4}>
                    {
                        productA.variant_id !== '' &&
                            <ProductItem
                                product={productA}
                                setProduct={setProductA}
                                alt={'producto-A'}
                                text={'Producto A seleccionado'}
                            />
                    }

                    {
                        productB.variant_id !== '' &&
                            <ProductItem
                                product={productB}
                                setProduct={setProductB}
                                alt={'producto-B'}
                                text={'Producto B seleccionado'}
                            />
                    }

                    {
                        productC.variant_id !== '' &&
                            <ProductItem
                                product={productC}
                                setProduct={setProductC}
                                alt={'producto-C'}
                                text={'Producto C seleccionado'}
                            />
                    }
                </Grid>

                {
                    (
                        productA.variant_id !== '' &&
                        productB.variant_id !== '' &&
                        productC.variant_id !== ''
                    ) ?
                        <Button sx={{ mt: 1 }}
                            variant="contained"
                            onClick={ checkPromo }>
                            Guardar promoción
                        </Button>
                    :
                        <Alert severity="info" sx={{ mt: 2 }}>
                            Seleccione todos los productos para guardar la promoción
                        </Alert>
                }

                <ProductSelect
                    text={'Producto A'}
                    setProduct={setProductA}
                    allProducts={allProducts}
                />

                <ProductSelect
                    text={'Producto B'}
                    setProduct={setProductB}
                    allProducts={allProducts}
                />

                <ProductSelect
                    text={'Producto C'}
                    setProduct={setProductC}
                    allProducts={allProducts}
                />
            </Grid>
        </Grid>
    );
};

export default PromoTwo;